import { shouldPolyfill } from '@formatjs/intl-locale/should-polyfill';
import { captureException } from '@tink/core/src/sentry';
import { XS2A } from './payments/DirectPayments/FTS/helpers/utils';

declare global {
  interface Window {
    Intl: any;
    xs2a: XS2A;
  }
}

// For some reason we are failing to import the chunk webpack crates from this
const loadIntlPolyfillThreeTimesAndThenErrorOut = async (cnt = 3) => {
  try {
    await import(/* webpackChunkName: 'intl-locale-polyfill' */ '@formatjs/intl-locale/polyfill');
  } catch (e) {
    if (cnt > 0) {
      await loadIntlPolyfillThreeTimesAndThenErrorOut(cnt - 1);
    } else {
      captureException(e);
    }
  }
};

export const loadIntlPolyfill = async () => {
  if (!window.Intl) {
    await import(/* webpackChunkName: 'intl-polyfill' */ 'intl');
  }

  if (shouldPolyfill()) {
    await loadIntlPolyfillThreeTimesAndThenErrorOut();
  }
};
